import type { ComparisonData } from "@/lib/comparison-data";

interface ComparisonTableProps {
  data: ComparisonData;
}

export default function ComparisonTable({ data }: ComparisonTableProps) {
  return (
    <section className="bg-background px-4 sm:px-6 xl:px-10 py-[60px] xl:py-[100px]">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col gap-8 xl:gap-[60px]">

        <div className="flex flex-col gap-4 xl:gap-[30px] w-full xl:w-[1360px] xl:h-[160px]">
          <h2 className="font-oswald font-medium text-[28px] sm:text-[42px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500 xl:h-[80px]">
            {data.title}
          </h2>
          <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300 xl:h-[50px]">
            {data.description}
          </p>
        </div>

        <div className="w-full xl:h-[1080px]">

          {/* Header */}
          <div className="bg-primary-500 rounded-[12px] w-full xl:h-[80px] flex items-center justify-between px-4 xl:px-5 py-4 xl:py-6">
            <div className="font-oswald font-medium text-[14px] sm:text-[16px] xl:text-[20px] leading-[100%] tracking-[0.2px] uppercase text-white flex-1">
              SPECIFICATION
            </div>
            <div className="xl:w-[492px] gap-4 xl:gap-5 flex">
              {data.columns.map((col) => (
                <div key={col} className="font-oswald font-medium text-[14px] sm:text-[16px] xl:text-[20px] leading-[100%] tracking-[0.2px] uppercase text-white flex-1 px-3 whitespace-nowrap flex items-center justify-center">
                  <span className="xl:w-[133px]">{col}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Body */}
          <div className="flex flex-col">
            {data.specifications.map((spec) => (
              <div key={spec.name} className="flex items-center justify-between py-4 xl:py-6 px-4 xl:px-5 w-full xl:h-[80px]">
                <div className="font-oswald font-medium text-[12px] sm:text-[14px] xl:text-[18px] leading-[100%] tracking-[0.2px] uppercase text-neutral-500 flex-1">
                  {spec.name}
                </div>
                <div className="xl:w-[492px] gap-4 xl:gap-5 flex flex-row items-center">
                  {spec.values.map((val, i) => (
                    <div key={i} className="font-roboto font-normal text-[12px] sm:text-[14px] xl:text-[16px] text-neutral-300 text-center flex-1 xl:w-[157px] py-[10px] px-3">
                      {Array.isArray(val) ? (
                        <div className="flex flex-col gap-1">
                          {val.map((item) => (
                            <div key={item}>{item}</div>
                          ))}
                        </div>
                      ) : (
                        val
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}